export default "__VITE_ASSET__CvO0opW5__"